<div class="fullscreen">

    <div class="row justify-content-center m-0 auth-box">
        <div class="col-sm-6 p-0">

            <form #loginForm="ngForm" (ngSubmit)="signup()">
            <mat-card class="p-0">
                <div class="primary-bg flex-display">
                    <button mat-icon-button class="m-auto" (click)="navigateToRoute(routes.AUTH)">
                        <mat-icon class="white">arrow_back</mat-icon>
                    </button>
                    <h3 translate class="align-text-center auth-header">SIGNIN.REGISTER</h3>
                </div>
                <div *ngIf="error" class="text-center alert alert-danger">
                    <p class="text-danger">{{ error.message }}</p>
                </div>
                <mat-card-content class="p-2">

                    <mat-form-field class="w-100">
                        <mat-icon matPrefix class="mr-2">person</mat-icon>
                        <input matInput #email="ngModel" type="text" placeholder="{{'SIGNIN.NAME_PLACEHOLDER' | translate }}" [(ngModel)]="name" name="name" required >
                    </mat-form-field>

                    <!-- Email address -->
                    <mat-form-field class="w-100">
                        <mat-icon matPrefix class="mr-2">email</mat-icon>
                        <input matInput #email="ngModel" type="text" placeholder="{{'SIGNIN.EMAIL_PLACEHOLDER' | translate }}" [(ngModel)]="username" name="username" required >
                    </mat-form-field>
                    
                    <!-- Password -->
                    <mat-form-field class="w-100">
                        <mat-icon matPrefix class="mr-2">lock</mat-icon>
                        <input matInput #pass="ngModel" type="password" name="password" placeholder="{{'SIGNIN.PASS_PLACEHOLDER' | translate }}" [(ngModel)]="password" name="pass" #pass="ngModel" required >
                        <mat-hint>{{ 'SIGNIN.PASSWORD_LENGTH' | translate }}</mat-hint>
                    </mat-form-field>

                    <!-- Confirm password -->
                    <mat-form-field class="w-100">
                        <mat-icon matPrefix class="mr-2">lock</mat-icon>
                        <input matInput #pass="ngModel" type="password" name="password" placeholder="{{'SIGNIN.PASS_CONFIRMATION' | translate }}" [(ngModel)]="confirmPassword" name="confirmPass" #confirmPass="ngModel" required >
                        <mat-hint>{{ 'SIGNIN.PASSWORD_CONFIRM' | translate }}</mat-hint>
                    </mat-form-field>
                </mat-card-content>

                <mat-card-actions class="m-0 p-2">
                    <button mat-raised-button color="primary" [disabled]="!loginForm.form.valid" type="submit" class="w-100 m-0">{{ 'SIGNIN.REGISTER_BTN' | translate }}</button>
                </mat-card-actions>
            </mat-card>
            </form>
        </div>
    </div>

</div>
<div *ngIf="loading">
    <div class="loading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>